import _ from 'underscore';
import { IUserInfo } from '../models/IUserInfo';
import { ILens, ILensDetail } from '../ServerApi/types/ILens';
import { MapperHelper } from './MapperHelper';
import { UserMapper } from './UserMapper';
import { ILensDetailInfo, ILensInfo } from '../models/ILensInfo';
import { INamedItemInfo } from '../models/resourceInfoParts';
import { FeatureFlags } from '../FeatureFlags';
import { ContentMapper } from './ContentMapper';
import { IUsageInfo } from '~src/ts/ServerApi/types/IUsageInfo';

export module LensMapper {

  const M = MapperHelper;


  export function map(
    serverApiLens: ILens[],
    users: _.Dictionary<IUserInfo>,
    favoriteLens: _.Dictionary<any> = {},
  projects: _.Dictionary<INamedItemInfo>
  ): ILensInfo[] {
    const lensToProject = ContentMapper.getContentToProjectMap(ContentMapper.ContentTypeToTargetMap.lens, projects);
    return _.map(serverApiLens, (p: ILens) => {

      const lensInfo: ILensInfo = {
        id:                           p.id,
        luid:                         p.luid,
        name:                         p.name,
        owner:                        UserMapper.mapOne(users[p.ownerId]),
        updatedAt:                    MapperHelper.toDate(p.updatedAt),
        contentType:                  'lens',
        project: (FeatureFlags.refactorProjectEnabled) ? lensToProject[p.id] : projects[p.projectId],
        favorite: false,
        usageInfo:                    {
          favoritesTotal: 0,
          hitsTotal: 0,
          hitsLastOneMonthTotal: 0,
          hitsLastThreeMonthsTotal: 0,
          hitsLastTwelveMonthsTotal: 0,
        },
        usageInfoMaxValues:           {
          favoritesTotal: 0,
          hitsTotal: 0,
          hitsLastOneMonthTotal: 0,
          hitsLastThreeMonthsTotal: 0,
          hitsLastTwelveMonthsTotal: 0,
        },
        description: p.description,
        repositoryUrl: '',
      };
      return lensInfo;
    });
  }

  export function mapDetail(p: ILensDetail): ILensDetailInfo {
    return {
      id:                           p.id,
      luid:                         p.luid,
      name:                         p.name,
      owner:                        UserMapper.mapOne(p.owner),
      updatedAt:                    MapperHelper.toDate(p.updatedAt),
      contentType:                  'lens',
      favorite:                     false,
      description:                  p.description,
      datasource:                   p.datasource,
      repositoryUrl:                p.repositoryUrl,
    };
  }

  export function mapFromCRASS(content: any): ILensInfo {
    return {
      updatedAt: M.toDate(content.modifiedTime) || M.toDateFromTimeOffsetObject(content.modifiedTime),
      description: content.description,
      id: content.id + '',
      luid: content.luid,
      name: content.title,
      favorite: false,
      contentType: 'lens',
      owner: UserMapper.mapOneOwnerFromCRASS(content),
      usageInfo: <IUsageInfo> {}, // does not exist in CRASS yet
      usageInfoMaxValues: <IUsageInfo> {}, // does not exist in CRASS yet
      project: {
        id: content.projectId ?? content.parentProjectId,
        name: content.containerName
      },
      repositoryUrl : '',
    };
  }
}
